import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=64745eb4"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=64745eb4&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64745eb4')) {
      api.createRecord('64745eb4', component.options)
    } else {
      api.reload('64745eb4', component.options)
    }
    module.hot.accept("./DetailList.vue?vue&type=template&id=64745eb4", function () {
      api.rerender('64745eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tool/DetailList.vue"
export default component.exports